import { render } from "./list-client.vue?vue&type=template&id=7bfe5cfc&scoped=true"
import script from "./list-client.vue?vue&type=script&lang=js"
export * from "./list-client.vue?vue&type=script&lang=js"

import "./list-client.vue?vue&type=style&index=0&id=7bfe5cfc&scoped=true&lang=css"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-7bfe5cfc"]])

export default __exports__